import http from './http';

const BASE = '/management/api-center';

export const getApiCatalog = async () => {
  const { data } = await http.get(`${BASE}/catalog`);
  return data;
};

export const getApiPermissionGroups = async () => {
  const { data } = await http.get(`${BASE}/permissions`);
  return data;
};

export const saveRoleApiGroupPermissions = async (roleId, groupPermissions) => {
  const { data } = await http.put(`${BASE}/roles/${roleId}/group-permissions`, { groupPermissions });
  return data;
};

export const executeApiRequest = async (request, filesByField = {}) => {
  if (request.bodyType === 'multipart') {
    const formData = new FormData();
    formData.append('request', JSON.stringify(request));
    Object.entries(filesByField || {}).forEach(([fieldName, fileList]) => {
      (fileList || []).forEach((file) => {
        const rawFile = file?.originFileObj || file;
        if (rawFile) formData.append(`files__${fieldName}`, rawFile);
      });
    });
    const { data } = await http.post(`${BASE}/execute`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: Number(request.timeout || 120000)
    });
    return data;
  }

  const { data } = await http.post(`${BASE}/execute`, request, {
    timeout: Number(request.timeout || 120000)
  });
  return data;
};

export const listApiCases = async (groupKey) => {
  const { data } = await http.get(`${BASE}/cases`, { params: groupKey ? { groupKey } : undefined });
  return data;
};

export const createApiCase = async (payload) => {
  const { data } = await http.post(`${BASE}/cases`, payload);
  return data;
};

export const updateApiCase = async (caseId, payload) => {
  const { data } = await http.put(`${BASE}/cases/${caseId}`, payload);
  return data;
};

export const deleteApiCase = async (caseId) => {
  const { data } = await http.delete(`${BASE}/cases/${caseId}`);
  return data;
};

export const listApiBatches = async () => {
  const { data } = await http.get(`${BASE}/batches`);
  return data;
};

export const createApiBatch = async (payload) => {
  const { data } = await http.post(`${BASE}/batches`, payload);
  return data;
};

export const updateApiBatch = async (batchId, payload) => {
  const { data } = await http.put(`${BASE}/batches/${batchId}`, payload);
  return data;
};

export const deleteApiBatch = async (batchId) => {
  const { data } = await http.delete(`${BASE}/batches/${batchId}`);
  return data;
};

export const addApiBatchItem = async (batchId, caseId) => {
  const { data } = await http.post(`${BASE}/batches/${batchId}/items`, { caseId });
  return data;
};

export const updateApiBatchItem = async (itemId, sortOrder) => {
  const { data } = await http.put(`${BASE}/batches/items/${itemId}`, { sortOrder });
  return data;
};

export const deleteApiBatchItem = async (itemId) => {
  const { data } = await http.delete(`${BASE}/batches/items/${itemId}`);
  return data;
};

export const executeApiBatch = async (batchId) => {
  const { data } = await http.post(`${BASE}/batches/${batchId}/execute`);
  return data;
};